<script setup lang="ts">
    import { CardMenu } from '@/components/ui/card';
    import { columns } from '@/tables/columns/user-companies';
    import { Head } from '@inertiajs/vue3';
    import { ref } from 'vue';
    import { useQuery } from '@tanstack/vue-query';
    import { useUrlSearch } from '@/composables/useUrlSearch';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem, NavItem } from '@/types';
    import type { ColumnFiltersState, SortingState } from '@tanstack/vue-table';

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'menu.employees',
            href: route('v2.user-companies.index'),
        },
    ];

    const navItems: NavItem[] = [
        {
            title: 'companies.header_user_companies',
            href: route('v2.user-companies.index'),
            permissionLevel: Permission.COMPANIES_VIEW,
        },
        {
            title: 'user-groups.header_users_groups',
            href: route('v2.user-groups.index'),
            permissionLevel: Permission.COMPANIES_VIEW,
        },
    ];
    const { extractAndCleanSearch } = useUrlSearch();
    const initialSearch = extractAndCleanSearch();

    const dataTableRef = ref<any>(null);

    const { isPending, data } = useQuery({
        queryKey: [QueryKey.USER_COMPANIES],
        queryFn: getUserCompanies,
    });

    async function getUserCompanies() {
        const { data } = await axios.get(route('v2.user-companies.table'), {
            params: {
                search: initialSearch || undefined,
            },
        });
        return data.data;
    }
</script>

<template>
    <Head :title="$t('profile.profile_settings')" />

    <AppLayout :breadcrumbs="breadcrumbs">
        <PageCard>
            <DataTable
                :table-key="QueryKey.USER_COMPANIES"
                ref="dataTableRef"
                :columns="columns"
                :data="data"
                :loading="isPending"
                :auto-url-search="true"
                :default-column-visibility="{
                    id: false,
                }"
            >
                <template #title>
                    <CardMenu :items="navItems" />
                </template>
            </DataTable>
        </PageCard>
    </AppLayout>
</template>
